import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'HOUSE_UPDATE',
    smsDelete : 'HOUSE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        house: [],
        house_count: null,
        submitSuccess: false,
        houseLoading: false,
        houseError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_HOUSE(state, {results, pg_count}) {
            state.house = results;
            state.house_count = pg_count;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        HOUSE_LOADING (state, loading) {
            state.houseLoading = loading;
        },

        HOUSE_ERROR (state, hasError) {
            state.houseError = hasError;
        }
    },

    actions: {
        async addHouse ({commit, dispatch}, payload) {
            commit('HOUSE_LOADING', true);
            commit('HOUSE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_house, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchHouse')
                return response

            } catch (e) {
                commit('HOUSE_ERROR', true);
            } finally {
                commit('HOUSE_LOADING', false);
            }
        },

        async fetchHouse ({ commit }, payload) { 
            commit('HOUSE_LOADING', true);
            commit('HOUSE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.search_term) params.append('search_term', payload.search_term);
                if (payload.shelter) params.append('shelter', payload.shelter);
                if (payload.house_condition) params.append('house_condition', payload.house_condition);
                if (payload.health_condition) params.append('health_condition', payload.health_condition);

                let url = V1API.house_list + '?' + params.toString();
                let result = await axios.get(url, config);
                const {results, pg_count} = result.data
                commit('SET_HOUSE', {results, pg_count});
                return result
            } catch(error) {
                commit('HOUSE_ERROR', true);
            } finally {
                commit('HOUSE_LOADING', false);
            }
        },

        async getHousesByUpazila ({ commit }, payload) {
            commit('HOUSE_LOADING', true);
            commit('HOUSE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.house_list_by_upazila + payload, config);
                let response = result.data
                commit('SET_HOUSE', response.data);

            } catch(error) {
                commit('HOUSE_ERROR', true);
            } finally {
                commit('HOUSE_LOADING', false);
            }
        },

        async updateHouse ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_house + payload.id, payload.house, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchHouse')
                return response

            } catch (e) {
                commit('HOUSE_ERROR', true);
            } finally {
                commit('HOUSE_LOADING', false);
            }
        },
        
        async deleteHouse({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.house_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchHouse')
            return response
        },

        async deleteOtherMembers({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            }; 

            let response = await axios.post(V1API.other_member_delete, {
                    ids: payload.ids
                }, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchHouse', {perPage:payload.perPage, currentPage:payload.page, search_term:payload.search_term, shelter:payload.shelter, health_condition:payload.health_condition, house_condition:payload.house_condition})
            return response
        },

        async editOtherMember({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            }; 

            let response = await axios.patch(V1API.other_member_edit + payload.id, {
                    other_member_age: payload.other_member_age,
                    other_member_gender: payload.other_member_gender,
                    other_member_health_condition: payload.other_member_health_condition,
                    home: payload.home
                }, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchHouse', {perPage:payload.perPage, currentPage:payload.page, search_term:payload.search_term, shelter:payload.shelter, health_condition:payload.health_condition, house_condition:payload.house_condition})
            return response
        },

        async editCoreMember({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            }; 

            let response = await axios.patch(V1API.core_member_edit + payload.id, {
                    age: payload.age,
                    gender: payload.gender,
                    health_condition: payload.core_health_condition,
                }, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchHouse', {perPage:payload.perPage, currentPage:payload.page, search_term:payload.search_term, shelter:payload.shelter, health_condition:payload.health_condition, house_condition:payload.house_condition})
            return response
        }
    },

    getters: {}
}
